module.exports = __webpack_public_path__ + "static/media/user-joseph-rowen.7908c7db.png";